import KeyCloakService from "../api/KeyCloakService";
import { AppContext } from "@/config/AppContext";
import { convertToPatient } from "./pipes/Mapper";
import { Patient } from "@/interfaces/Patient";

export default {
  async fetchPatients(): Promise<object> {
    try {
      const headers = {
        Authorization: `Bearer ${KeyCloakService.GetAccessToken()}` || "",
      };
      const url = AppContext.getApiUrlPath() + "/patients";
      //alert(url);
      const response = await fetch(url, {
        method: "GET",
        headers: headers,
        body: null,
      });
      console.log(response);
      if (!response.ok) {
        console.error("Unable to fetch patients:" + response);
        throw new Error("Unable to fetch patients");
      }
      const data = await response.json();
      //const doctors = data.map((apiData: any) => convertToDoctor(apiData));
      console.log(data);
      return data;
    } catch (error) {
      throw new Error("Unable to fetch patients");
    }
  },
  async fetchPatient(patientId: string): Promise<Patient> {
    try {
      const headers = {
        Authorization: `Bearer ${KeyCloakService.GetAccessToken()}` || "",
        "Content-Type": "application/json",
      };
      const url = AppContext.getApiUrlPath() + "/patients/" + patientId;
      const response = await fetch(url, {
        method: "GET",
        headers: headers,
        body: null,
      });
      if (!response.ok) {
        console.error("Unable to fetch patient:");
        console.error(response);
        throw new Error("unable to");
      }
      return convertToPatient(await response.json());
    } catch (error) {
      throw new Error("Unable to get patient");
    }
  },
  async sendActivationReminder(patientId: string): Promise<{ lastReminderAt: string }> {
    const headers = {
      Authorization: `Bearer ${KeyCloakService.GetAccessToken()}` || "",
      "Content-Type": "application/json",
    };
    const url = AppContext.getApiUrlPath() + "/admin/patients/" + patientId + "/activation-reminder";
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
    });
    if (!response.ok) {
      throw new Error("Unable to send activation reminder");
    }
    return await response.json();
  },
  async fetchPatientsByDoctorId(doctorId: string): Promise<object> {
    try {
      const headers = {
        Authorization: `Bearer ${KeyCloakService.GetAccessToken()}` || "",
      };
      const url =
        AppContext.getApiUrlPath() + "/doctors/" + doctorId + "/patients?page=0&perPage=100";
      const response = await fetch(url, {
        method: "GET",
        headers: headers,
        body: null,
      });
      console.log(response);
      if (!response.ok) {
        console.error("Unable to fetch patients:" + response);
        throw new Error("Unable to fetch patients");
      }
      const data = await response.json();
      //const doctors = data.map((apiData: any) => convertToDoctor(apiData));
      console.log(data);
      return data.content;
    } catch (error) {
      throw new Error("Unable to fetch patients");
    }
  },
};
